import type { ConfigType } from '@plone/registry';
import { RouteCondition } from '@plone/volto/helpers/Slots';
import WeatherBand from '../components/WeatherBand/WeatherBand';

export default function installSlots(config: ConfigType) {
  config.registerSlotComponent({
    slot: 'belowHeader',
    name: 'weatherBand',
    component: WeatherBand,
    predicates: [RouteCondition('/', true)],
  });
  return config;
}
